// Prefill repair for the LearnWorlds Module-12 button (Story 10.10, AC 2).
//
// The button links here with `?email={{USER.EMAIL}}` UNENCODED (proven live
// 2026-07-20/23 with r.korzen+lw_*@softkraft.co), so a literal `+` in the local
// part reaches URLSearchParams as a space (the parser treats `+` as an encoded
// space). A space is invalid in a local part, so normalizing internal spaces
// back to `+` is unambiguous. The repair runs before DISPLAY and before
// SUBMISSION (the screen re-repairs the field value at submit — the user may
// paste a space-mangled address by hand).

/** Normalize internal spaces back to `+` (trim first — edge whitespace is padding). */
export function repairUnencodedPlus(value: string): string {
  return value.trim().replace(/ /g, "+");
}

// Deliberately loose (the backend re-validates): just enough to keep a
// malformed parameter from prefilling garbage into the field.
const PLAUSIBLE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Read the `?email=` prefill from a location search string.
 *
 * Repaired, or `""` when the parameter is absent or still malformed after the
 * repair (AC 2: empty field, no error).
 */
export function readEmailPrefill(search: string): string {
  const raw = new URLSearchParams(search).get("email");
  if (!raw) return "";
  const repaired = repairUnencodedPlus(raw);
  return PLAUSIBLE_EMAIL.test(repaired) ? repaired : "";
}
